<template>
    <div class="knowledge">
        <div class="knowledge-top">
            <van-swipe class="top-swipe" :autoplay="3000" :show-indicators="false" @change="onSwipeChange">
                <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                    <div class="top-banner" :style="{ backgroundImage: 'url(' + item + ')' }"></div>
                </van-swipe-item>
                <div class="custom-indicator" slot="indicator">
                    <span
                        v-for="(item, index) in bannerList"
                        :key="`indicator-${index}`"
                        :class="['indicator-dot', { active: index === currentSwipe }]"
                    ></span>
                </div>
            </van-swipe>
        </div>

        <div class="article-list">
            <div v-if="!loading && finished && articleList.length === 0" class="empty-state">
                <van-empty description="暂无内容" />
            </div>
            <van-list
                v-else
                v-model="loading"
                :finished="finished"
                @load="onLoad"
            >
                <div
                    class="article-item"
                    v-for="(item, index) in articleList"
                    :key="item.id || index"
                    @click="openDetail(item)"
                >
                    <div
                        class="article-cover"
                        :style="item.cover ? { backgroundImage: 'url(' + item.cover + ')' } : null"
                    ></div>
                    <div class="article-content">
                        <div class="article-title">{{ item.title }}</div>
                        <div class="article-footer">
                            <span class="article-date">{{ item.createTime }}</span>
                            <span :class="['read-tag', item.isRead === '已阅读' ? 'read' : 'unread']">
                                <img class="tag-icon" :src="seeIcon" alt="">
                                <span class="tag-text">{{ item.isRead || '未阅读' }}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import { getTW, getBannerList } from '@/api/index.js';

const defaultBannerImg = require('@/assets/image/evaluation-top-bg.png');

export default {
    data() {
        return {
            currentSwipe: 0,
            seeIcon: require('@/assets/image/see-icon.png'),
            bannerList: [defaultBannerImg],
            articleList: [],
            pageNum: 1,
            pageSize: 10,
            loading: false,
            finished: false,
            total: 0
        };
    },
    created() {
        this.loadBannerList();
        this.loadArticleList(false);
    },
    methods: {
        loadBannerList() {
            getBannerList({
                type: '知识学习'
            })
                .then(res => {
                    const records = Array.isArray(res?.data?.records) ? res.data.records : [];
                    const urls = records.map(item => item.img).filter(Boolean);
                    this.bannerList = urls.length > 0 ? urls : [defaultBannerImg];
                })
                .catch(() => {
                    this.bannerList = [defaultBannerImg];
                });
        },
        onSwipeChange(index) {
            this.currentSwipe = index;
        },
        onLoad() {
            this.loadArticleList(true);
        },
        openDetail(item) {
            this.$router.push({ name: 'knowledgeDetail', query: { id: item.id } });
        },
        loadArticleList(isLoadMore = false) {
            if (this.loading || this.finished) return;

            this.loading = true;
            const data = {
                pageNum: this.pageNum,
                pageSize: this.pageSize
            };

            getTW(data).then(res => {
                const records = res.data?.records || [];
                const total = Number(res.data?.total || 0);
                if (isLoadMore) {
                    this.articleList = [...this.articleList, ...records];
                } else {
                    this.articleList = records;
                }

                this.total = total;
                if (this.articleList.length >= total || records.length < this.pageSize) {
                    this.finished = true;
                } else {
                    this.pageNum += 1;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
                this.finished = true;
            });
        }
    }
};
</script>

<style scoped lang="scss">
.knowledge {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}

.knowledge-top {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 100%;
    height: 300px;
    background: #ffffff;

    .top-swipe {
        width: 100%;
        height: 300px;
        overflow: hidden;
        position: relative;
    }

    .top-banner {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
    }

    .custom-indicator {
        position: absolute;
        left: 50%;
        bottom: 90px;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .indicator-dot {
        width: 30px;
        height: 4px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.55);
        transition: all 0.2s ease;
    }

    .indicator-dot.active {
        background: #ffffff;
    }
}

.article-list {
    flex: 1;
    padding: 20px 15px 80px;
    margin-top: -80px;
    position: relative;
    z-index: 2;
    background: linear-gradient(to bottom, #C2E5EB, #EEF4F5);
    border-radius: 20px 20px 0 0;
}

.article-item {
    display: flex;
    gap: 12px;
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:last-child {
        margin-bottom: 0;
    }
}

.article-cover {
    width: 110px;
    height: 80px;
    border-radius: 8px;
    background: linear-gradient(120deg, #89d9f7, #4bb9ee);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    flex-shrink: 0;
}

.article-content {
    flex: 1;
    min-width: 0;
}

.article-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 1.3;
    margin-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
}

.article-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.article-date {
    font-size: 11px;
    color: #9c9c9c;
}

.read-tag {
    display: inline-flex;
    align-items: center;
    height: 24px;
    border-radius: 4px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.read-tag.read {
    background-image: url('~@/assets/image/read-icon.png');
}

.read-tag.unread {
    background-image: url('~@/assets/image/unread-icon.png');
}

.tag-icon {
    width: 24px;
    height: 24px;
    padding: 5px;
    box-sizing: border-box;
    object-fit: contain;
    flex-shrink: 0;
}

.tag-text {
    padding: 0 8px;
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
}

.read .tag-text {
    color: #46CCDC;
}

.unread .tag-text {
    color: #FF7A00;
}

.empty-state {
    padding: 40px 20px;
}
</style>
